import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Alert = _resolveComponent("Alert");
    const _component_PluginComponent = _resolveComponent("PluginComponent");
    return (_openBlock(), _createBlock(_component_PluginComponent, {
        modelValue: _ctx.open,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.open) = $event)),
        infoPayload: _ctx.infoPayload,
        onOnUserArgChanged: _ctx.onUserArgChanged,
        actionBtnTxt: "Paste"
    }, {
        afterForm: _withCtx(() => [
            _createVNode(_component_Alert, {
                class: "mt-3",
                type: "info"
            }, {
                default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.formatMsg), 1)
                ]),
                _: 1
            })
        ]),
        _: 1
    }, 8, ["modelValue", "infoPayload", "onOnUserArgChanged"]));
}
